import { gql } from "@apollo/client";

export default gql`
  fragment ComplianceProgramForReportAssessmentGroupSection on AssessmentGroupSectionNode {
    id
    templateContextId
    title
    description
    questions {
      edges {
        node {
          id
          templateContextId
          question {
            ...ComplianceProgramReportQuestion
          }
        }
      }
    }
  }

  fragment ComplianceProgramForReportAssessmentGroup on AssessmentGroupNode {
    id
    templateContextId
    title
    sections {
      edges {
        node {
          ...ComplianceProgramForReportAssessmentGroupSection
        }
      }
    }
  }
`;
